import { Component, OnInit } from '@angular/core';
import { DalService } from 'src/app/services/dal.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-homepage2',
  templateUrl: './homepage2.component.html',
  styleUrls: ['./homepage2.component.css']
})
export class Homepage2Component implements OnInit {

  lstVolumeLeader = [];
  lstTicker = [];
  lstTopGainer = [];
  lstTopLoser = [];
  lstIndexes = [];
  subscription: any;

  constructor(
    private dal: DalService,
    private ls: LocalStorageService,
  ) { 
    this.getMarketData();
  }

  getMarketData() {
    this.getLocalMarketData();
    this.dal.getVolumeLeaderData().then((res: any) => {
      this.getLocalMarketData();
    })
    this.dal.getTopGainerData().then((res: any) => {
      this.getLocalMarketData();
    })
    this.dal.getTopLoserData().then((res: any) => {
      this.getLocalMarketData();
    })
    this.dal.getIndexData().then((res: any) => {
      this.getLocalMarketData();
    })
    this.dal.getTickerData().then((res: any) => {
      this.getLocalMarketData();
    })    
  }

  getLocalMarketData(){
    this.ls.getObject("VolLeaders").then((res: any) => {
      this.lstVolumeLeader = res;
    });
    this.ls.getObject("TopGainers").then((res: any) => {
      this.lstTopGainer = res;
    });
    this.ls.getObject("TopLosers").then((res: any) => {
      this.lstTopLoser = res;
    });
    this.ls.getObject("Indexes").then((res: any) => {
      this.lstIndexes = res;
    });
    this.ls.getObject("Tickers").then((res: any) => {
      this.lstTicker = res;
    });
  }

  ngOnInit() {
    this.subscription = interval(10000).subscribe(x => {
      this.getMarketData();
    });
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

}
